import { MenuItem } from 'primeng/api';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ApiV6Service } from '@service/apiv6.service';
import { MessagesService } from '@core/_services/messages.service';
import { lastValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-add-resbsk',
    templateUrl: './add-resbsk.component.html',
    styleUrls: ['./add-resbsk.component.scss'],
})
export class AddResBskComponent implements OnInit {

    @Input()
    public requestList = [];

    @Input()
    public basketList = [];

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    public items: Array<MenuItem>;

    constructor(private api: ApiV6Service, protected _messageService: MessagesService,
        private translate: TranslateService) {
    }

    ngOnInit() {
    }

    public async validate (request) {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('updateresbsk', this.api.createResBsk(request, 0, [])));
            this.onValidate.emit({ data: wRes.data, create: true });
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
            return;
        }
    }

    cancel() {
        this.onCancel.emit({ id: null });
    }
}
